/**
 * Aircraft Hooks
 * Custom hooks for aircraft data management using React Query
 */

import { useQuery } from '@tanstack/react-query';
import aircraftService from '../services/aircraftService';

/**
 * Hook to fetch all aircraft with optional filters
 */
export const useAircraft = (filters?: {
  isActive?: boolean;
  aircraftType?: string;
  search?: string;
}) => {
  return useQuery({
    queryKey: ['aircraft', filters],
    queryFn: () => aircraftService.getAircraft(filters),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

/**
 * Hook to fetch active aircraft only
 */
export const useActiveAircraft = () => {
  return useQuery({
    queryKey: ['aircraft', 'active'],
    queryFn: () => aircraftService.getActiveAircraft(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

/**
 * Hook to fetch aircraft formatted for form options
 */
export const useAircraftOptions = () => {
  return useQuery({
    queryKey: ['aircraft', 'options'],
    queryFn: () => aircraftService.getAircraftOptions(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

/**
 * Hook to fetch a single aircraft by ID
 */
export const useAircraftById = (id: number) => {
  return useQuery({
    queryKey: ['aircraft', id],
    queryFn: () => aircraftService.getAircraftById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};